import Cookies from 'js-cookie';
import { environment } from "@/env/env.prod";
import { getHeaders } from '@/api/requestHeaders';

const BASE = `${environment.BASE_URL}/alumni`;

export class AlumniService {

    async getAll(params: {
        instituteCode: string;
        limit?: number;
        startAfter?: string | null;
        search?: string;
        employmentStatus?: string;
        graduationYear?: string;
        sector?: string;
        linkedinLinked?: string;
        country?: string;
    }) {
        const q = new URLSearchParams();
        Object.entries(params).forEach(([ k, v ]) => {
            if (v !== null && v !== undefined && v !== '') q.set(k, String(v));
        });
        const res = await fetch(`${BASE}/getAll?${q.toString()}`, { headers: getHeaders() });
        return res.json();
    }

    async getFilters(instituteCode: string) {
        const res = await fetch(`${BASE}/filters?instituteCode=${instituteCode}`, { headers: getHeaders() });
        return res.json();
    }

    async delete(uids: string[], instituteCode: string) {
        const res = await fetch(`${BASE}/delete`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ uids, instituteCode }),
        });
        return res.json();
    }

    async deleteByEIds(eIds: string[], instituteCode: string) {
        const res = await fetch(`${BASE}/delete`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ eIds, instituteCode }),
        });
        return res.json();
    }

    async validateToken(token: string) {
        const res = await fetch(`${BASE}/validate?token=${token}`);
        return res.json();
    }

    async submitSurvey(token: string, form: Record<string, unknown>, countryName: string) {
        const res = await fetch(`${BASE}/submit`, {
            method: 'POST',
            headers: getHeaders(),
            body: JSON.stringify({ token, ...form, country: countryName }),
        });
        return res.json();
    }

    private chunk<T>(arr: T[], size: number): T[][] {
        return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
            arr.slice(i * size, i * size + size)
        );
    }
}

export const alumniService = new AlumniService();